import { render, staticRenderFns } from "./IntegrationChannelsOverview.vue?vue&type=template&id=60559ae3&scoped=true"
import script from "./IntegrationChannelsOverview.vue?vue&type=script&lang=ts"
export * from "./IntegrationChannelsOverview.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationChannelsOverview.vue?vue&type=style&index=0&id=60559ae3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60559ae3",
  null
  
)

export default component.exports